// Source: https://zeroheight.com/1ql67vy16/p/37c34c
// Note: Do not use this file's exports when writing bonfire components.
//  Use `bonfireGet` instead.
// Naming scheme:
// Campout colors are nested 3 deep, ex: "Primary" => "Default" => "Dark"
// Concatenate the section names in camel case, and omit any instances of "Default".
export var primaryDark = "#007298";
export var primaryAccent = "#6EC4E9";
export var primaryLight = "#D9F3FC";
export var primaryVariantDark = "#003A4C";
export var secondary = "#00A7E1";
export var secondaryVariant = "#FFA933";
export var complementaryDark = "#98262B";
export var complementary = "#D9272D";
export var complementaryAccent = "#F0907B";
export var complementaryLight = "#F7D3CB";
export var complementaryVariantDark = "#F5B21E";
export var complementaryVariant = "#FFC745";
export var complementaryVariantAccent = "#FED771";
export var complementaryVariantLight = "#F8EED5";
export var analogousDark = "#025963";
export var analogous = "#00AABD";
export var analogousAccent = "#4FDCEB";
export var analogousLight = "#A5F1F9";
export var analogousVariantDark = "#007B61";
export var analogousVariant = "#00B085";
export var analogousVariantAccent = "#84CDB8";
export var analogousVariantLight = "#D6F3EB";
export var analogousVariant2Dark = "#00795F";
export var analogousVariant2 = "#00C089";
export var analogousVariant2Accent = "#66B8B7";
export var tertiaryDark = "#614A9D";
export var tertiary = "#967ADC";
export var tertiaryAccent = "#BAA2F6";
export var tertiaryLight = "#DCD0FB";
export var surfaceDark = "#354052";
export var surface = "#677A90";
export var surfaceAccent = "#A1AEBB";
export var surfaceLight = "#DEE2E6";
export var surfaceVariant = "#8494A6";
export var surfaceVariantLight = "#E9F1F4";
export var background = "#F6F6F6";
export var backgroundLight = "#FFFFFF";
// =======================================
// Validation Colors
// =======================================
export var validationSuccessDark = "#007A1D";
export var validationSuccess = "#24A749";
export var validationSuccessAccent = "#029123";
export var validationWarningDark = "#DDA500";
export var validationWarning = "#FFC32F";
export var validationWarningAccent = "#EFB300";
export var validationDangerDark = "#7C010D";
export var validationDanger = "#BD2A35";
export var validationDangerAccent = "#9A0311";
export var validationDangerLight = "#F7D3CB";
// =======================================
// Text Colors
// =======================================
// These use the same colors as the above, but are kept seperate so they can be changed independently.
export var textDark = "#354052";
export var textLight = "#FFFFFF";
export var linkLight = "#00A7E1";
export var linkDark = "#007298";
export var linkDisabled = "#A1AEBB";
//# sourceMappingURL=colors.js.map